
interface Props {
    title: string;
    text?: string;
}

export function LoadingIndicator({ title, text }: Props) {
    return (
        <div className='loading-indicator__panel'>
            <div className='loading-indicator__spinner' aria-hidden='true' />
            <div>
                <div className='loading-indicator__title'>{title}</div>
                {text && <div className='loading-indicator__text'>{text}</div>}
            </div>
        </div>
    );
}
